import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-patient-search',
  templateUrl: './patient-search.component.html',
  styleUrl: './patient-search.component.scss',
  providers: [Location]
})
export class PatientSearchComponent {
  isAggregator = false;

  constructor(private router: Router) {
    const url = this.router.url;
    this.isAggregator = url.includes('pms-aggregator');
  }

  onToggle(event: any) {
    this.isAggregator = event.target.checked;
    if (this.isAggregator) {
      this.router.navigate(['/patient-search/pms-aggregator']);
    } else {
      this.router.navigate(['/patient-search/pms']);
    }
  }
}
